<template>
  <div class="flex justify-center items-center text-center">
    <div class="font-general-regular text-lg text-ternary-dark dark:text-ternary-light">
      <p class="font-general-medium duration-500">
        {{ projectName }}
        designed by Takanori Fujiki
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyrightDate: new Date().getFullYear(),
      projectName: 'Portfolio Site 2025',
      author: 'Takanori Fujiki',
    };
  },
};
</script>